import React, { useRef } from 'react';
import { TextField } from '@material-ui/core';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CurrencyInputProps {
    id: string;
    label: string;
    name: string;
    value: number | undefined | null;
    onChange: (value: number) => void;
    error: boolean;
    helperText: string | null | undefined;
    disabled: boolean;
}

export const CurrencyNewInput = React.forwardRef<any, CurrencyInputProps>((props, ref) => {
    const { id, label, name, value, onChange, error, helperText, disabled } = props;

    const handleValueChange = (values: any) => {
        const { floatValue } = values;
        onChange(floatValue);
    };

    return (
        <TextField
            id={id}
            label={label}
            name={name}
            fullWidth
            variant="standard"
            placeholder="R$ 0,00"
            error={error}
            helperText={helperText}
            disabled={disabled}
            InputProps={{
                inputComponent: NumericFormatCustom as any,
                inputProps: {
                    value: value,
                    onValueChange: handleValueChange,
                },
            }}
            inputRef={ref}
        />
    );
});

const NumericFormatCustom = React.forwardRef<any, NumericFormatProps>(function NumericFormatCustom(props, ref) {
    const { onValueChange, onBlur, ...other } = props;
    const localInputRef = useRef<HTMLInputElement | null>(null);

    const handleFocus = () => {
        if (localInputRef.current) {
            localInputRef.current.setSelectionRange(0, 0);
        }
    };

    return (
        <NumericFormat
            {...other}
            getInputRef={(el: HTMLInputElement) => {
                if (ref) {
                    (ref as any).current = el;
                }
                localInputRef.current = el;
            }}
            onValueChange={onValueChange}
            onBlur={onBlur}
            onFocus={handleFocus}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            prefix="R$ "
            allowNegative={false}
        />
    );
});